import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "homePage",
		component: () => import(/* webpackChunkName: "home" */ "@/views/HomePage/HomePage.vue"),
		meta: {
			keepAlive: true, // 需要被缓存
			inNav: true,
			navName: "首页",
		},
	},
	{
		path: "/scheme",
		name: "schemePage",
		component: () => import(/* webpackChunkName: "schemePage" */ "@/views/SchemePage/SchemePage.vue"),
		meta: {
			keepAlive: true, // 需要被缓存
			inNav: true,
			navName: "解决方案",
		},
	},
	{
		path: "/product",
		name: "productPage",
		component: () => import(/* webpackChunkName: "productPage" */ "@/views/ProductPage/ProductPage.vue"),
		meta: {
			keepAlive: true, // 需要被缓存
			inNav: true,
			navName: "产品展示",
		},
	},
	{
		path: "/case",
		name: "casePage",
		component: () => import(/* webpackChunkName: "casePage" */ "@/views/CasePage/CasePage.vue"),
		meta: {
			keepAlive: true, // 需要被缓存
			inNav: true,
			navName: "经典案例",
		},
	},
	{
		path: "/news",
		name: "newsCenter",
		component: () => import(/* webpackChunkName: "news" */ "@/views/NewsCenter/NewsCenter.vue"),
		meta: {
			keepAlive: true, // 需要被缓存
			inNav: true,
			navName: "新闻中心",
		},
	},
	{
		path: "/about",
		name: "aboutPage",
		component: () => import(/* webpackChunkName: "aboutPage" */ "@/views/AboutPage/AboutPage.vue"),
		meta: {
			keepAlive: true, // 需要被缓存
			inNav: true,
			navName: "关于我们",
		},
	},
	{
		path: "/newsDetail",
		name: "newsDetail",
		component: () => import(/* webpackChunkName: "newsDetail" */ "@/views/NewsCenter/NewsDetail/NewsDetail.vue"),
		meta: {
			keepAlive: false, // 不需要被缓存
		},
	},

	{
		path: "/schemeDetail",
		name: "schemeDetail",
		component: () => import(/* webpackChunkName: "schemeDetail" */ "@/views/SchemePage/SchemeDetail/SchemeDetail.vue"),
		meta: {
			keepAlive: false, // 不需要被缓存
		},
	},
	{
		path: "/caseDetail",
		name: "caseDetail",
		component: () => import(/* webpackChunkName: "caseDetail" */ "@/views/CasePage/CaseDetail/CaseDetail.vue"),
		meta: {
			keepAlive: false, // 不需要被缓存
		},
	},
	{
		path: "/productDetail",
		name: "productDetail",
		component: () => import(/* webpackChunkName: "productDetail" */ "@/views/ProductPage/ProductDetail/ProductDetail.vue"),
		meta: {
			keepAlive: false, // 不需要被缓存
		},
	},
	{
		path: "/404",
		name: "errorPage",
		component: () => import(/* webpackChunkName: "aboutPage" */ "@/views/Error404/Error404.vue"),
		meta: {
			keepAlive: true, // 需要被缓存
		},
	},
];

const router = new VueRouter({
	routes,
	mode: "history",

	scrollBehavior(to, from, saveTop) {
		if (saveTop) {
			return saveTop;
		} else {
			return { x: 0, y: 0 };
		}
	},
});
router.beforeEach((to, from, next) => {
	if (!hasRoute(to)) {
		next({ name: "errorPage" });
	} else {
		next();
	}
});
const hasRoute = to => {
	let find = router.getRoutes().find(item => item.name === to.name);
	return !!find;
};
export default router;
